import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, {
/*useEffect,*/
useState, useCallback } from 'react';
import { useEffect } from 'react';
import { useMeasure } from 'react-use';
import globalEvents from '@/utils/globalEvents';
import { nowUnix } from '@/utils/date';
import useWorkbook from '@/components/Editor/hooks/useWorkbook';
import useAbandonChanges from '@/components/ConfirmationPrompt/hooks/useAbandonChanges';
import useParseFileUpload from '@/components/Editor/hooks/useParseFileUpload';
import useDataSourceSelect, { DataSource } from './hooks/useDataSourceSelect';
import ModalHoc from '@/components/ModalHoc';
import AddNew from './AddNew';
import Editor from './Editor';
import modalStyles from '@/components/ModalHoc/styles.module.scss';
import displayModalStyles from '@/components/ModalHoc/stylesDisplay.module.scss'; // const PREFIX = 'components: Editor: modals: Data:';

import { jsx as _jsx } from "react/jsx-runtime";
const MODAL_ID = 'data-editor-modal';

const DataModal = _ref => {
  let {
    user,
    widget,
    workbookName,
    workbookId,
    workbookData: workbookDataSrc,
    workbookMeta: workbookMetaSrc,
    workbookUpdatedAt,
    workbookSyncedAt,
    workbookOrigin,
    workbookSyncConfig,
    workbookSyncStatus,
    activeSelection,
    defaultShowErrors = false,
    defaultDataSource,
    onSubmit,
    onChangeWorkbook,
    onEditSelectionsNext,
    onClose
  } = _ref;
  const [ref, {
    width
  }] = useMeasure();
  const {
    1:
    /*selections*/
    setSelections
  } = useState('');
  const {
    0: localUpdatedAt,
    1: setLocalUpdatedAt
  } = useState(workbookUpdatedAt);
  const {
    workbook,
    workbookMeta,
    isLoading,
    hasUpdates,
    fileOrigin,
    name,
    localSave,
    upload,
    sheetNames,
    getGoogleDriveFile,
    subscribe,
    unsubscribe,
    errors: spreadsheetErrors
  } = useWorkbook({
    widget,
    workbookName,
    workbookSrc: workbookDataSrc,
    sheetNamesSrc: workbookMetaSrc.sheetNames,
    workbookFormatsSrc: workbookMetaSrc.formats,
    workbookGridsSrc: workbookMetaSrc.grids,
    workbookStylesSrc: workbookMetaSrc.styles,
    workbookCellDataSrc: workbookMetaSrc.cellData,
    fileOriginSrc: workbookOrigin,
    workbookUpdatedAt
  });
  const {
    dataSource,
    options: dataSourceOptions,
    handleSelect: handleDataSourceSelect,
    handleDeselect: handleDataSourceDeselect
  } = useDataSourceSelect({
    isLoggedIn: Boolean(user),
    defaultValue: defaultDataSource
  });
  const {
    parseFileUpload
  } = useParseFileUpload({
    uploadFn: upload,
    subscriptionActive: user === null || user === void 0 ? void 0 : user.subscriptionActive,
    onBeforeUpload: () => handleDataSourceDeselect(),
    onSuccess: () => setLocalUpdatedAt(nowUnix())
  }); // Is local file origin up to date w/ remote state

  const isfileOriginUpToDate = Boolean((fileOrigin === null || fileOrigin === void 0 ? void 0 : fileOrigin.originFileId) && (fileOrigin === null || fileOrigin === void 0 ? void 0 : fileOrigin.originFileId) === (workbookOrigin === null || workbookOrigin === void 0 ? void 0 : workbookOrigin.originFileId)); // Emit the finalize changes event
  // before submitting the changes

  const triggerSubmit = useCallback(() => globalEvents.trigger('univerSheetFinalizeChangesStart'), []); // Publish any user updates to workbook
  // or any of the styles/formatting etc

  const handleSubmit = useCallback(result => {
    onSubmit(result.workbook, result.workbookMeta, name ? name : '', fileOrigin); // Close modal

    typeof onClose === 'function' && onClose();
  }, [name, fileOrigin, onSubmit, onClose]); // Emit the finalize changes event
  // before opening the selection editor

  const triggerEditSelectionsNext = useCallback(() => globalEvents.trigger('univerSheetFinalizeChangesStart', {
    detail: {
      id: 'edit-selections-next'
    }
  }), []); // Subscribe to the finalizing changes event

  useEffect(() => {
    return globalEvents.subscribe('univerSheetFinalizeChangesEnd', event => {
      handleSubmit(event.detail); // Optionally open the selection editor next

      const eventId = event.detail.id;

      if (eventId === 'edit-selections-next') {
        onEditSelectionsNext();
      }
    });
  }, [handleSubmit, onEditSelectionsNext]); // Publish user updates to the Data Editor's,
  // local workbook and/or meta data

  const handleChange = useCallback((workbookData, workbookMeta) => {
    localSave(workbookData, workbookMeta, name);
    setLocalUpdatedAt(nowUnix());
  }, [localSave, setLocalUpdatedAt, name]);

  const handleAddNewData = value => {
    handleDataSourceSelect(value);
  }; // Confirm user wants to close modal
  // if there are any unsaved changes


  useAbandonChanges({
    id: MODAL_ID,
    title: 'Are you sure you want to abandon your changes without saving?',
    // Immediately close if no updates
    // or if the data is syncing
    hasUpdates: hasUpdates && workbookSyncStatus !== 'active',
    // Close modal if user discards changes
    onCancel: onClose,
    // Submit changes if user confirms
    onConfirm: triggerSubmit
  }); // The user allowed to proceed to edit selections after save

  const canEditSelectionsNext = typeof onEditSelectionsNext === 'function';
  return /*#__PURE__*/_jsx("div", {
    className: displayModalStyles.container
    /* @ts-ignore */
    ,
    ref: ref,
    children: dataSource ? /*#__PURE__*/_jsx(AddNew, {
      workbookId: workbookId,
      containerWidth: width,
      isLoading: isLoading,
      dataSource: dataSource,
      dataSourceOptions: dataSourceOptions,
      getGoogleDriveFile: getGoogleDriveFile,
      onClose: () => {
        if (defaultDataSource === DataSource.LOCAL_FILE) {
          typeof onClose === 'function' && onClose();
        } else {
          handleDataSourceDeselect();
        }
      },
      onChange: parseFileUpload,
      onChangeDataSource: handleAddNewData,
      onChangeWorkbook: onChangeWorkbook,
      user: user
    }) : /*#__PURE__*/_jsx(Editor, _objectSpread({
      workbookName: name,
      workbookId: workbookId,
      workbookData: workbook,
      workbookMeta: workbookMeta,
      containerWidth: width,
      isLoading: isLoading,
      sheetNames: sheetNames,
      hasUpdates: hasUpdates,
      canCompleteSyncEnable: isfileOriginUpToDate,
      activeSelection: activeSelection,
      defaultShowErrors: defaultShowErrors,
      workbookOrigin: fileOrigin || workbookOrigin || {},
      workbookUpdatedAt: localUpdatedAt,
      workbookSyncedAt: workbookSyncedAt,
      workbookSyncConfig: workbookSyncConfig,
      errors: spreadsheetErrors,
      dataSourceOptions: dataSourceOptions,
      onAddNewData: handleAddNewData,
      onChange: handleChange,
      onSelectionsChange: cellRefs => setSelections(cellRefs),
      onSubmit: triggerSubmit,
      onSubscribe: subscribe,
      onUnSubscribe: unsubscribe
    }, canEditSelectionsNext ? {
      onEditSelectionsNext: triggerEditSelectionsNext
    } : {}))
  });
};

export default ModalHoc(DataModal, {
  modalClass: modalStyles['container--big'],
  overlayclass: modalStyles['overlay--high'],
  hasCloseButton: false,
  closeOnEvent: false,
  closeOnOverlayClick: false
});